<div #pageTop>
  <app-wrapper size="xl" isFitWithSmallScreen="true" @enter>
    <app-content-row>
      <app-card-content [showSeparator]="true">
        <app-card-content-head>
          <mat-icon class="card-content-head-icon">bookmarks</mat-icon>
          お気に入り管理
        </app-card-content-head>
        <app-card-content-nav (menuClick)="menuClickHandler($event)" [menus]="menus"></app-card-content-nav>
        <app-wrapper size="fluid">
          <app-content-row>
            <div class="flex flex-wrap gap-y-2 items-end">
              <div class="mr-4 -mb-6">
                <mat-form-field appearance="outline" class="w-32 md:w-auto">
                  <mat-label>科目</mat-label>
                  <mat-select [(value)]="selectedSubjectId" (selectionChange)="onChangeSubject()">
                    <mat-option *ngFor="let subject of subjects$ | async" [value]="subject.id">
                      {{ subject.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <span class="mx-auto"></span>

              <!-- TODO: click action -->
              <div>
                <button mat-flat-button class="bg-gray-30 hover:bg-gray-50" [disabled]="isLimitExceeded" (click)="addBookmarkProblemList()">
                  <i class="text-primary material-symbols-outlined text-lg -mt-[1px]">list_alt_add</i>
                  新規お気に入りリスト
                </button>
              </div>
            </div>
          </app-content-row>
        </app-wrapper>

        <div @enter *ngIf="!isListsLoading; else loadingProgress">
          <app-wrapper size="fluid">
            <app-content-row>
              <app-table-overflow>
                <table mat-table *ngIf="dataSource.data.length > 0" [dataSource]="dataSource" style="min-width: 1200px;">
                  <ng-container matColumnDef="listName">
                    <th mat-header-cell *matHeaderCellDef>
                      <div class="ml-2">
                        <div *ngIf="isOwnTabSelected">
                          お気に入りリスト数: <b>{{ dataSource.data.length - 1 }}</b
                          >個 (上限{{ listMaxCount }}個)
                        </div>
                        <div *ngIf="!isOwnTabSelected">
                          お気に入りリスト数: <b>{{ dataSource.data.length }}</b
                          >個
                        </div>
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let element" class="university font-bold">
                      <button
                        (click)="goToProblemListPage(element.visibility, element.id)"
                        class="flex items-center gap-1 text-primary group p-1"
                      >
                        <mat-icon class="shrink-0">list_alt</mat-icon>
                        <span class="underline group-hover:no-underline font-semibold">{{ element.listName }}</span>
                      </button>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="problemCount">
                    <th mat-header-cell *matHeaderCellDef>登録数</th>
                    <td mat-cell *matCellDef="let element" class="problemCount text-sm">
                      {{ element.problemCount }}
                      {{ element.visibility === VisibilityType.UNCATEGORIZED ? '' : ' / ' + problemMaxCount }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="owner">
                    <th mat-header-cell *matHeaderCellDef>オーナー</th>
                    <td mat-cell *matCellDef="let element" class="owner text-sm">{{ element.owner }}</td>
                  </ng-container>

                  <ng-container *ngIf="isOwnTabSelected" matColumnDef="visibility">
                    <th mat-header-cell *matHeaderCellDef>公開設定</th>
                    <td
                      mat-cell
                      *matCellDef="let element"
                      [ngClass]="{
                        'visibility-uncategorized': element.visibility === VisibilityType.UNCATEGORIZED,
                        'visibility-private': element.visibility === VisibilityType.PRIVATE,
                        'visibility-shared': element.visibility === VisibilityType.SCHOOL_ONLY
                      }"
                    >
                      {{ element.visibilityLabel }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="updatedAt">
                    <th mat-header-cell *matHeaderCellDef class="updatedAt-header">最終更新日時</th>
                    <td mat-cell *matCellDef="let element" class="updatedAt text-sm">{{ element.updatedAt }}</td>
                  </ng-container>

                  <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef>アクション</th>
                    <td mat-cell *matCellDef="let element" class="action text-sm">
                      <div *ngIf="isOwnTabSelected">
                        <div *ngIf="element.visibility !== VisibilityType.UNCATEGORIZED">
                          <button
                            mat-icon-button
                            [matMenuTriggerFor]="mylistKebabMenu"
                            aria-label="action for mylist"
                            class="hover:opacity-75"
                          >
                            <mat-icon class="text-sub -mt-[3px]">more_vert</mat-icon>
                          </button>
                          <mat-menu #mylistKebabMenu="matMenu">
                            <button mat-menu-item (click)="updateBookmarkProblemList(element.id, element.listName, element.visibility)">
                              <mat-icon class="mr-2">create</mat-icon>
                              <span class="font-semibold text-md">編集・公開設定</span>
                            </button>
                            <button
                              mat-menu-item
                              [disabled]="isLimitExceeded"
                              (click)="copyBookmarkProblemList(element.id, element.listName)"
                            >
                              <mat-icon class="mr-2">content_copy</mat-icon>
                              <span class="font-semibold text-md">複製</span>
                            </button>
                            <button mat-menu-item (click)="deleteBookmarkProblemList(element.id, element.listName)">
                              <mat-icon class="mr-2">delete_forever</mat-icon>
                              <span class="font-semibold text-md">削除</span>
                            </button>
                          </mat-menu>
                        </div>
                      </div>

                      <div *ngIf="!isOwnTabSelected">
                        <button
                          mat-icon-button
                          [matMenuTriggerFor]="fromMemberListKebabMenu"
                          aria-label="action for mylist"
                          class="hover:opacity-75"
                        >
                          <mat-icon class="text-sub -mt-[3px]">more_vert</mat-icon>
                        </button>
                        <mat-menu #fromMemberListKebabMenu="matMenu">
                          <button
                            mat-menu-item
                            (click)="copyBookmarkProblemList(element.id, element.listName)"
                            [disabled]="isLimitExceeded"
                          >
                            <mat-icon class="mr-2">content_copy</mat-icon>
                            <span class="font-semibold text-sm">自分のお気に入りリストへ複製</span>
                          </button>
                        </mat-menu>
                      </div>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="columns"></tr>
                  <tr mat-row *matRowDef="let row; columns: columns"></tr>
                </table>
              </app-table-overflow>
            </app-content-row>
            <app-content-row *ngIf="dataSource.data.length === 0">
              <app-content-no-data>
                <span>共有されたリストはありません</span>
              </app-content-no-data>
            </app-content-row>
          </app-wrapper>
        </div>
      </app-card-content>
      <div class="mt-4">
        <p class="text-sub text-sm">※ 共有された問題リストは、共有元がチームを離れると閲覧できなくなります。必要な場合は複製してください</p>
      </div>
    </app-content-row>
  </app-wrapper>

  <ng-template #loadingProgress>
    <div class="progress-48-search-result-loading py-6 md:py-8">
      <mat-spinner [diameter]="48"></mat-spinner>
    </div>
  </ng-template>
</div>
